import { render, staticRenderFns } from "./gongsibao.vue?vue&type=template&id=70900c04&scoped=true&"
import script from "./gongsibao.vue?vue&type=script&lang=js&"
export * from "./gongsibao.vue?vue&type=script&lang=js&"
import style0 from "./gongsibao.vue?vue&type=style&index=0&id=70900c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70900c04",
  null
  
)

export default component.exports